import toast from "react-hot-toast";
import { flowTypes } from "../types";
import { Dispatch } from "redux";
import CustomToast from "components/common/CustomToast";
import { flowService } from "services/Ldb";

export const flowActions = {
    setFlowMode,
    resetFlowMode,
    fetchInsights,
    resetInsights,
    sendFlowFeedback,
    resetFlowFeedback,
    showPreviousChatLayout,
};

function setFlowMode(mode: string) {
    return (dispatch: Dispatch) => {
        dispatch(request(flowTypes.FLOW_MODE_REQUEST));

        flowService.setFlowMode(mode).then(
            (res) => {
                dispatch(success(flowTypes.FLOW_MODE_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(flowTypes.FLOW_MODE_FAILURE, error?.message));
                }
            }
        );
    };
}

function fetchInsights() {
    return (dispatch: Dispatch) => {
        dispatch(request(flowTypes.FETCH_INSIGHTS_REQUEST));

        flowService.getInsights().then(
            (res) => {
                dispatch(success(flowTypes.FETCH_INSIGHTS_SUCCESS, res?.data));
            },
            (error) => {
                dispatch(failure(flowTypes.FETCH_INSIGHTS_FAILURE, error?.message));
            }
        );
    };
}

function sendFlowFeedback(data: Record<string, any> | Array<Record<string, any>>) {
    return (dispatch: Dispatch) => {
        dispatch(request(flowTypes.SEND_FLOW_FEEDBACK_REQUEST));

        flowService.sendFlowFeedback(data).then(
            (res) => {
                dispatch(success(flowTypes.SEND_FLOW_FEEDBACK_SUCCESS, res?.data));
            },
            (error) => {
                dispatch(failure(flowTypes.SEND_FLOW_FEEDBACK_FAILURE, error?.message));
            }
        );
    };
}

function showPreviousChatLayout(show: boolean) {
    return (dispatch: Dispatch) => {
        dispatch(success(flowTypes.SHOW_PREVIOUS_CHAT_LAYOUT, show));
    };
}

function resetFlowFeedback() {
    return (dispatch: Dispatch) => {
        dispatch(success(flowTypes.SEND_FLOW_FEEDBACK_SUCCESS, null));
    };
}

function resetInsights() {
    return (dispatch: Dispatch) => {
        dispatch(success(flowTypes.FETCH_INSIGHTS_SUCCESS, null));
    };
}

function resetFlowMode() {
    return (dispatch: Dispatch) => {
        dispatch(success(flowTypes.FLOW_MODE_SUCCESS, null));
    };
}

function request(type: string) {
    return { type: type };
}
function success(type: string, data?: any) {
    return { type: type, payload: data };
}
function failure(type: string, error?: any) {
    return { type: type, payload: error ?? "" };
}
